









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * @deprecated
 * 会員登録時に大文字を含むメールアドレスは自動で小文字に変換される。
 * ユーザーは大文字で登録したつもりだが、大文字でログインを試みるとログインできないことになる。
 * そのため入力したメールアドレスに大文字が含まれている場合、小文字でのログインを試してくださいというメッセージを出すことにした。
 * 本来はEngine側で対応するべきものなので、この実装は暫定的な対応である。
 * @see https://github.com/Everforth/growthpalette-front/issues/8851
 */
@Component
export default class IncorrectAuthenticationDataContainsUppercaseError extends Vue {
  @Prop({ default: 'p' })
  readonly tag: string
}
